import React from "react";
import Sidebar from "../components/Sidebar"; // Import the Sidebar component
import { Outlet } from "react-router-dom";

const RadiologistDashboard = () => {
  // Sidebar items
  const items = [
    { name: "Dashboard", link: "/radiologist", icon: "🏠" },
    { name: "Image Management", link: "/radiologist/image-management", icon: "👤" },
    
  ];

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Sidebar items={items} />
      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px" }}>
        <h1>Radiologist Dashboard</h1>
        {/* Outlet for nested routes */}
        <Outlet />
      </div>
    </div>
  );
};

export default RadiologistDashboard;
